import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminNavBar.css';

const NAV_ITEMS = [
  { to: '/app/admin', label: 'Dashboard', end: true },
  { to: '/app/admin/ingestion', label: 'Ingestion', end: false },
  { to: '/app/admin/analytics', label: 'Analytics', end: false },
  { to: '/app/admin/errors', label: 'Errors', end: false },
  { to: '/app/admin/alerts', label: 'Alerts', end: false }
];

export default function AdminNavBar() {
  return (
    <nav className='admin-nav'>
      <span className='admin-nav-brand'>⚙ Admin</span>
      <div className='admin-nav-links'>
        {NAV_ITEMS.map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `admin-nav-link${isActive ? ' admin-nav-link--active' : ''}`
            }
          >
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
